import type { ReactNode } from "react";
import { Colors } from "../../../styles/theme";

export function WelcomeSectionShell({ children }: { children: ReactNode }) {
  return (
    <section className="bg-white px-7 pb-10 pt-5 text-[#022A59]">
      {children}
    </section>
  );
}

export function WelcomeH2({ children }: { children: ReactNode }) {
  return <h2 className="text-xl font-bold" style={{ color: Colors.AZUL_GOV_DARK }}>{children}</h2>;
}

export function WelcomeH3({ children }: { children: ReactNode }) {
  return <h3 className="text-xl font-bold" style={{ color: Colors.AZUL_GOV_DARK }}>{children}</h3>;
}

export function WelcomeP({
  children,
  className = "",
}: {
  children: ReactNode;
  className?: string;
}) {
  return (
    <p className={`mt-1 text-sm leading-relaxed text-slate-600 ${className}`}>
      {children}
    </p>
  );
}
